import { Link } from 'react-router-dom';

import { Details, SimpleTable } from '@nearst/ui';
import { useShop } from '@services/ShopProvider';
import { useIsChain } from '@utils/useIsChain';

import styles from './BarcodeVisibilityModal.module.scss';

const ResultsSection = ({ results, operation }) => {
	const { data: allShops } = useShop();
	const isChain = useIsChain();

	if (!results.length) return null;

	const successes = results.filter((result) => !result.failures.length).length;
	const failures = results.filter((result) => result.failures.length).length;

	const summary = [successes > 0 && `${successes} ${operation.successMessage}`, failures > 0 && `${failures} failures`]
		.filter(Boolean)
		.join(', ');

	if (!failures) {
		return (
			<div className={styles.summary}>
				{successes} {operation.successMessage}
			</div>
		);
	}

	return (
		<Details title={summary} className={styles.resultsSection}>
			<SimpleTable
				data={results.filter((result) => result.failures.length)}
				fields={[
					{
						title: 'Barcode',
						formatter: (row) => row.barcode
					},
					isChain && {
						title: 'Failures',
						formatter: (row) => {
							const items = [];
							for (const shopId of row.failures) {
								if (items.length > 1) {
									items.push(` and ${row.failures.length - items.length} others`);
									break;
								}

								const shop = allShops.find((shop) => shop.id === shopId);
								if (!shop) continue;

								items.push(
									<>
										{items.length ? ', ' : ''}
										<Link to={`/inventory/${shopId}/items/${row.barcode}`} className={styles.link}>
											{shop.name}
										</Link>
									</>
								);
							}
							return items;
						}
					}
				].filter(Boolean)}
			/>
		</Details>
	);
};

export default ResultsSection;
